import { XIconSmall } from '../../../../icon';
import { NakedButton } from '../../../../naked';
import { styles } from '../../../../styles';
import { Text } from '../../../text';
import { MultiselectSelectionStyles } from './multiselect-selection.styles';

type Props = {
  children: React.ReactNode;
  onRemove: () => void;
  selectionCount: number;
};

export const MultiselectSelection = ({ children, onRemove, selectionCount }: Props) => {
  const themedText = MultiselectSelectionStyles.textStyles({
    selectionCount,
  });
  const themedButton = MultiselectSelectionStyles.buttonStyles;

  return (
    <Text size='medium' color='light' css={themedText}>
      <span css={styles.truncate}>{children}</span>
      <NakedButton css={themedButton} onClick={onRemove} aria-label='Remove option' type='button'>
        <XIconSmall />
      </NakedButton>
    </Text>
  );
};
